export default __webpack_public_path__ + "static/media/icon-facebook-black.bacc2dc1.svg";